import additionalOutput from './additionalOutput';
import aspectRatios from './aspectRatios';
import durations from './durations';
import rushEdit from './rushEdit';
import captions, { CAPTION_SAMPLES } from './captions';
import chromaKey from './chromaKey';
import voiceOverArtist from './voiceOverArtist';
import supersizeMyEdit from './supersizeMyEdit';

export default function ({ isInternal } = {}) {
  return {
    ADDITIONAL_OUTPUT: additionalOutput(),
    ASPECT_RATIOS: aspectRatios(),
    DURATIONS: durations(),
    RUSH_EDIT: rushEdit(),
    CAPTIONS: captions(),
    CAPTION_SAMPLES,
    CHROMA_KEY: chromaKey({ isInternal }),
    VOICE_OVER_ARTIST: voiceOverArtist(),
    SUPERSIZE_MY_EDIT: supersizeMyEdit()
  };
}